import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconTextbox = props => (
  <SvgIcon {...props} viewBox="0 0 14 16">
    <path d="m6 14v-12h-6v-2h14v2h-6v12h1v2h-4v-2h1z" />
  </SvgIcon>
);

export default IconTextbox;



// WEBPACK FOOTER //
// ./src/components/icons/IconTextbox.js